namespace TabAurous.Retail {
    export namespace OpenConsignmentInBifurcationService {
        export const baseUrl = 'Retail/OpenConsignmentInBifurcation';

        export declare function List(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<Reports.StockBifurcationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function CustomerList(request: ReportFiltersRequest, onSuccess?: (response: Serenity.ListResponse<Reports.StockBifurcationRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/OpenConsignmentInBifurcation/List",
            CustomerList = "Retail/OpenConsignmentInBifurcation/CustomerList"
        }

        [
            'List', 
            'CustomerList'
        ].forEach(x => {
            (<any>OpenConsignmentInBifurcationService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
